'use client'

import { ClubPointsHistoryBlock } from 'cms-types'
import {
  ClubPointsHistory as ClubPointsHistoryUI,
  type LoadableComponentProps,
  type LocalizedComponentProps,
} from 'ui'

import { formatDate } from '@/cms/helpers'
import { ClubMembershipStatus, useClubMembership } from '@/hooks/useClubMembership'
import { useCustomer } from '@/store/customerStore'

export function ClubPointsHistoryClient({
  locale,
  data,
  loading,
}: LocalizedComponentProps<LoadableComponentProps<ClubPointsHistoryBlock>>) {
  const customer = useCustomer(c => c.customer)
  const membership = useClubMembership()

  // Members only. Gating on membership (not just `customer`) stops a persisted
  // customer's points history from flashing before membership is known.
  if (membership !== ClubMembershipStatus.Member) return null
  if (loading || !customer) return <ClubPointsHistoryUI loading />

  const orders =
    customer?.orders?.flatMap(order =>
      order.points
        ? [
            {
              date: formatDate(order.processedAt, locale),
              points: order.points,
            },
          ]
        : [],
    ) ?? []

  return <ClubPointsHistoryUI data={{ ...data, points: customer?.points ?? 0, orders }} />
}
